import styled from 'styled-components';

export const TileContainer = styled.div`
  margin: 10px 90px 30px;
`;

export const DetailsText = styled.div`
  color: ${({ theme }) => theme.baseBlue.a6};
  font-size: ${({ theme }) => theme.sz.textFontSize};
  background: ${({ theme }) => theme.white.a10};
  padding: 20px;

  li,
  p,
  h1,
  h2,
  h3 {
    margin: 1rem 0;
  }

  h1:first-of-type {
    margin-top: 0rem;
  }
`;
